var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageFail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16A8 8 0 118 0a8 8 0 010 16z",
    fill: "#FE5B4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15 11.75a.5.5 0 00.5.5h.7a.5.5 0 00.5-.5v-.7a.5.5 0 00-.5-.5h-.7a.5.5 0 00-.5.5v.7zm0-2.85a.5.5 0 00.5.5h.7a.5.5 0 00.5-.5V4.2a.5.5 0 00-.5-.5h-.7a.5.5 0 00-.5.5v4.7z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/message-fail.f3b4e375.svg";
export { SvgMessageFail as ReactComponent };